<template>
	<b-taglist class="multi-tags">
		<b-tag
			rounded
			v-for="tag in tags"
			:key="tagName(tag)"
			:class="tagClass(tag)"
			:size="tagSize == 'is-default' ? undefined : tagSize"
		>
			{{ tagFormatter(tagName(tag)) }}
		</b-tag>
	</b-taglist>
</template>

<script>
	export default {
		name: "MultiTags",
		props: {
			tags: {
				type: Array,
				required: true
			},
			showMissing: {
				type: Boolean,
				default: false,
			},
			classJoiner: {
				type: String,
				required: true,
			},
			tagFormatter: {
				type: Function,
				default: (tag) => tag,
			},
			tagSize: {
				type: String,
				default: 'is-default',
				validator: v => ['is-default', 'is-medium', 'is-large'].indexOf(v) >= 0
			}
		},
		methods: {
			tagName(tag) {
				return this.showMissing ? tag.name : tag;
			},
			tagClass(tag) {
				return {
					"multi-tag": true,
					"tag-present": this.showMissing ? tag.present : true,
					[`${this.classJoiner}--${this.tagName(tag)}`]: true,
				}
			}
		},
	}
</script>

<style lang="scss">
.tags.multi-tags {
	padding-left: 16.5%;
	padding-right: 16.5%;
	// display: flex;
	justify-content: center;
	// align-items: center;
	align-items: center;

	&:not(:last-child) {
		margin-bottom: 0.5rem;
	}
}
.multi-tag {
	padding: 0.25rem;
	border: 2px solid;
	font-weight: bold;
	border-radius: 10px;
	font-size: 1rem;
	background-color: transparent;
}
.tag.multi-tag {
	background-color: transparent;
}
.multi-tag:not(.tag-present) {
	border-color: hsl(0, 0%, 92%) !important;
	color: hsl(0, 0%, 92%) !important;
}
</style>